import React from 'react';
import ComponentField from '../../form/ComponentField';
import createForm from "./Form";
import {CurrencyFormatter, UnitFormatter} from "../../../utils/formatters";
import {UnitConvertComponent} from "src/components/classes/Unit";

class CompositeProductExtraForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />    
                    </div>
                    <div className="col-md-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="product"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Extra termék"
                        />    
                    </div>
                    <div className="col-md-4 unit">
                        <UnitConvertComponent
                            value={this.props.values.qty}
                            unit={this.props.values.material?.unit}
                        >
                            {({convertFrom, value, formatted}) => <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="qty"
                                values={{qty: value}}
                                setFieldValue={(field, value) => this.props.setFieldValue(field, convertFrom(value))}
                                label="Mennyiség"
                                negative={true}
                                formatter={() => formatted}
                                placeholder={(() => formatted?.props?.children || "")}
                                type="decimal"
                            />}
                        </UnitConvertComponent>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(CompositeProductExtraForm);
